import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {Store, UserState} from './store';
import {ListStore} from "./listStore";

@Injectable({ providedIn: 'root' })
export class UserListQuery extends QueryEntity<UserState> {

  constructor(
    protected store: ListStore,
  ) {
    super(store);
  }

}
